import { createReducer, on } from '@ngrx/store';
import { IPersona } from 'src/app/interfaces/personas.interface';
import { GetPersonasSuccess } from '../actions/personas.actions';

export interface IPersonasState {
  personas: IPersona[];
}

export const initialPersonasState: IPersonasState = {
  personas: []
};

export const personasReducers = createReducer(
  initialPersonasState,
  on(GetPersonasSuccess, (state, { personas }) => {
    return {
        ...state,
        personas
    };
  })
);
